/**
 * @author David Oravec<xorave06@stud.fit.vutbr.cz>
 */
import React from 'react';
import {Alert, Button, CircularProgress, Grid, TextField, Typography} from "@mui/material";
import {CHECK_EMAIL} from "../../data/formats";
import {useNavigate} from "react-router-dom";

function LoginView(props) {
    const {isSubmitting, onPasswordChange, onEmailChange, creds, submit, info} = props
    const navigate = useNavigate()
    return (
        <Grid container justifyContent={"center"} alignItems={"center"} alignContent={"center"} rowSpacing={2} marginX={"auto"} minHeight={"90vh"}>
            <Grid item xs={12}>
                <Typography variant={"h3"} component={"h1"} textAlign={"center"}>Prihlásenie</Typography>
            </Grid>
            <Grid item xs={12}>
                <form onSubmit={submit} style={{maxWidth: 250, margin: "0 auto"}}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Alert severity={info.severity}>{info.text}</Alert>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                autoFocus={true}
                                error={creds.email !== "" && !CHECK_EMAIL.test(creds.email)}
                                id="email"
                                label="Email"
                                type={"email"}
                                value={creds.email}
                                onChange={onEmailChange}
                                disabled={isSubmitting}
                                fullWidth
                                helperText={creds.email === "" || CHECK_EMAIL.test(creds.email)? "":"Zlý formát emailu"}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                id="password"
                                label="Heslo"
                                value={creds.password}
                                type={"password"}
                                onChange={onPasswordChange}
                                disabled={isSubmitting}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Button fullWidth variant={"contained"} type="submit" disabled={isSubmitting} endIcon={isSubmitting ? <CircularProgress size={10}/> :""}>Prihlásiť sa</Button>
                        </Grid>
                        <Grid item xs={12}>
                            <Button fullWidth color="warning" variant={"contained"} type="submit" onClick={()=>{navigate("/register", { replace: true })}}>Registrovať sa</Button>
                        </Grid>
                    </Grid>
                </form>
            </Grid>

        </Grid>
    );
}

export default LoginView;